import { createElement, forwardRef, HtmlHTMLAttributes, memo, ReactInstance, ReactNode } from "react";
import { createPortal, findDOMNode } from "react-dom";
import { useMergedRef } from "../../utils";

export const getPortalComponents = () => {
  const virtualDomNode = document.createElement("div");

  const processRef = (node: ReactInstance | null | undefined) => {
    const domNode = findDOMNode(node) as Element;
    if (domNode) {
      domNode.append(virtualDomNode);
    }
  };

  const PortalContentProvider = ((props: { children?: ReactNode }) => createPortal(props.children, virtualDomNode));

  const Container = memo(forwardRef<any, HtmlHTMLAttributes<HTMLDivElement>>((props, ref) =>
    createElement("div", {
      ...props,
      ref: useMergedRef(processRef, ref),
    })));

  return {
    Container,
    PortalContentProvider,
  };
};
